import { useEffect } from 'react';
import { Divider, InputNumber, Form } from 'antd';

import { WizardDescription } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardDescription';
import WizardContentBox from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardContentBox';
import WizardTitle from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/components/WizardTitle';

import useWizard from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/context/useWizard';
import 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/styles/WizardQuestionHelp.less';

const ProductCountStep = ({ step }) => {
  const formInstance = Form.useFormInstance();

  const { state, actions } = useWizard();

  const { content, field } = step;
  const value = state.answers[field];

  const handleChange = (val) => {
    actions.setAnswer(field, val);
  };

  useEffect(() => {
    formInstance.setFieldsValue({ [field]: value ?? null });
  }, [field, formInstance, value]);

  return (
    <WizardContentBox>
      <WizardTitle title={content.title} />
      <Divider />
      <div className='wizard-question-row wizard-question-row--input'>
        <WizardDescription>{content.question}</WizardDescription>
        <Form.Item
          name={field}
          preserve={false}
          rules={[
            {
              required: true,
              message: 'Please input the number of products',
            },
          ]}
          style={{ marginBottom: 0 }}
        >
          <InputNumber
            onChange={handleChange}
            placeholder={content.placeholder}
            min={1}
            precision={0}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </div>
    </WizardContentBox>
  );
};

export default ProductCountStep;
